import React, { useState } from "react";
import PageHeader from "../../common/components/PageHeader";
import { Box, Grid, Stack, Typography, useTheme } from "@mui/material";
import { East, FiberManualRecord } from "@mui/icons-material";
import CommonCard from "../../common/components/CommonCard";
import { ProfileTabs, tabs } from "../../common/const";
import PersonalInfo from "./PersonalInfo";
import BasicInformation from "./BasicInformation";
import Activity from "./Activity";
import CodingInfo from "./CodingInfo";
import ResearchInfo from "./ResearchInfo";
import IntakeForm from "./IntakeForm";
import Certificates from "./Certificate";

const MyProfile = () => {
    const theme = useTheme();
    const [activeTab, setActiveTab] = useState(0);

    return (
        <Box
            sx={{
                height: '85vh',
                overflow: 'auto'
            }}
        >
            <PageHeader
                title="My Profile Manager"
                content={
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <Typography color="text.secondary" sx={{ fontSize: 14,  }}>
                            Home
                        </Typography>
                        <FiberManualRecord sx={{ fontSize: 8, color: 'text.secondary' }} />
                        <Typography color="text.secondary" sx={{ fontSize: 14,  }}>
                            Settings
                        </Typography>
                    </Stack>
                }
            />
            <Grid container spacing={2} mt={0.5}>
                <Grid item md={2.4}>
                    <CommonCard
                        background={theme.palette.background.main}
                        borderRadius={1}
                        paddingBottom="0px"
                        padding="0px"
                        marginTop="0px"
                        content={
                            <Box display='flex' flexDirection='column'>
                                {tabs.map((tab) => (
                                    <Box
                                        key={tab.id}
                                        sx={{
                                            display: 'flex',
                                            background: theme.palette.primary.main,
                                            padding: '16px 13px',
                                            cursor: 'pointer',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            gap: 0.5
                                        }}
                                        onClick={() => setActiveTab(tab.id)}
                                    >
                                        <Box display="flex" alignItems="center" gap={1}>
                                            <img src={tab.activeIcon} alt={tab.label} height="22px" />
                                            <Typography color={theme.palette.secondary.main} fontWeight={activeTab === tab.id ? 600 : 400} fontSize={14}>
                                                {tab.label}
                                            </Typography>
                                        </Box>
                                        {activeTab === tab.id && (
                                            <East sx={{ color: theme.palette.secondary.main }} />
                                        )}
                                    </Box>
                                ))}
                            </Box>
                        }
                    />
                </Grid>
                <Grid item md={9.6}>
                    {activeTab === ProfileTabs.personalInfo && (
                        <PersonalInfo />
                    )}
                    {activeTab === ProfileTabs.academic && (
                        <BasicInformation />
                    )}
                    {activeTab === ProfileTabs.curricular && (
                        <Activity />
                    )}
                    {activeTab === ProfileTabs.coding && (
                        <CodingInfo />
                    )}
                    {activeTab === ProfileTabs.research && (
                        <ResearchInfo />
                    )}
                    {activeTab === ProfileTabs.intakeform && (
                        <IntakeForm />
                    )}
                    {activeTab === ProfileTabs.certificates && (
                        <Certificates />
                    )}
                </Grid>
            </Grid>
        </Box>
    )
}

export default MyProfile;